import React from 'react';
import PropTypes from 'prop-types';
import Asset from '../../../../requests/apa/Asset';


const Image = ({ assetKey, height, width }) => (
    <img src={Asset.get(assetKey)} style={{ height, width, position: 'relative', display: 'block' }} />
);

Image.propTypes = {
    assetKey: PropTypes.string.isRequired,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default Image;


// WEBPACK FOOTER //
// ./src/containers/config/components/Image/Image.jsx